import React from 'react';
import styled from 'styled-components';
import { Modal as BaseModal } from '@ubeya/shared-web/components';
import EmployeesContent from './EmployeesContent';

const Modal = styled(BaseModal)`
  height: 95vh;
  max-height: unset;
`;

const EmployeesModal = ({
  isShift,
  params,
  checkboxData,
  filters,
  setFilters,
  disabledFilters,
  onClose,
  onConfirm,
  item
}) => (
  <Modal size="medium" onClose={onClose} onConfirm={onConfirm} title="Employees" isPaddingContent={false} usePortal>
    <EmployeesContent
      isShift={isShift}
      params={params}
      checkboxData={checkboxData}
      item={item}
      filters={filters}
      setFilters={setFilters}
      disabledFilters={disabledFilters}
    />
  </Modal>
);

export default EmployeesModal;
